import { createFileRoute, redirect } from "@tanstack/react-router"

import { getProductQualityTabRoute } from "./_layout"

export const PRODUCT_QUALITY_INDEX_LAYOUT_ROUTE_PATH = "/app/product/$productId/edit/_layout/quality/"

export const Route = createFileRoute(PRODUCT_QUALITY_INDEX_LAYOUT_ROUTE_PATH)({
  beforeLoad: async ({ params }) => {
    return redirect({ to: getProductQualityTabRoute(params.productId) })
  },
})
